import { isSameUsScope } from '@/lib/polymarketUs/portfolioModel';
import type { UsTrackerRead } from './usTrackerFeed';

/** A combined position total needs every own-account reader, including the
 * interval after listing accounts and before their readers have mounted.
 * Refreshing an unchanged scope may keep its last successful snapshot. */
export function usPositionsComplete(read: UsTrackerRead | null): boolean {
  if (!read || read.list.state !== 'listed' || !read.list.complete
    || !Number.isSafeInteger(read.ownAccounts) || read.ownAccounts < 0
    || read.accounts.length !== read.ownAccounts
    || new Set(read.accounts.map(account => account.accountId)).size !== read.accounts.length) return false;
  return read.accounts.every(account => {
    const { context, snapshot } = account;
    return !account.opening && !account.openError && !account.readError && !!context && !!snapshot
      && context.accountId === account.accountId && context.permissions.viewOwn
      && isSameUsScope(context.scope, snapshot.scope) && snapshot.readDetails?.view === 'own'
      && snapshot.readDetails.inventory.state === 'complete';
  });
}
